import { TFunction } from "@einride/saga-core"
import { FilterTerm } from "gen/graphql"

// getGroupColumnName maps grouping columns to a readable name that will be displayed to the user.
export function getGroupColumnName(columnId: string, t: TFunction<"explore">): string {
  switch (columnId) {
    case "origin_location_name":
    case "origin_location_display_name":
      return t("reportPage.location.key")
    case "vehicle_energy_source":
      return t("reportPage.vehicleEnergySource.key")
    case "space_name":
    case "space_display_name":
      return t("reportPage.space.key")
    case "origin_city":
      return t("reportPage.originCity.key")
    case "delivered_by_vehicle_display_name":
      return t("reportPage.deliveredByVehicle.key")
    case "destination_city":
      return t("reportPage.destinationCity.key")
    case "destination_country_code":
      return t("reportPage.destinationCountryCode.key")
    case "destination_location_name":
    case "destination_location_display_name":
      return t("reportPage.destinationLocation.key")
    case "origin_country_code":
      return t("reportPage.originCountryCode.key")
    case "owner_organization_name":
      return t("reportPage.ownerOrganizationName.key")
    case "status":
      return t("reportPage.status.key")
    case "lane":
    case "lane_display_name":
      return t("reportPage.lane.key")
    case "vehicle_drive_type":
      return t("reportPage.vehicleDriveType.key")
    default:
      return columnId
  }
}

// getGroupColumnDescription maps grouping columns to a description that will be displayed to the user.
export function getGroupColumnDescription(columnId: string, t: TFunction<"explore">): string {
  switch (columnId) {
    case "origin_location_name":
    case "origin_location_display_name":
      return t("reportPage.location.description")
    case "vehicle_energy_source":
      return t("reportPage.vehicleEnergySource.description")
    case "space_name":
    case "space_display_name":
      return t("reportPage.space.description")
    case "origin_city":
      return t("reportPage.originCity.description")
    case "delivered_by_vehicle_display_name":
      return t("reportPage.deliveredByVehicle.description")
    case "destination_city":
      return t("reportPage.destinationCity.description")
    case "destination_country_code":
      return t("reportPage.destinationCountryCode.description")
    case "destination_location_name":
    case "destination_location_display_name":
      return t("reportPage.destinationLocation.description")
    case "origin_country_code":
      return t("reportPage.originCountryCode.description")
    case "owner_organization_name":
      return t("reportPage.ownerOrganizationName.description")
    case "status":
      return t("reportPage.status.description")
    case "lane":
    case "lane_display_name":
      return t("reportPage.lane.description")
    case "vehicle_drive_type":
      return t("reportPage.vehicleDriveType.description")
    default:
      return ""
  }
}

export function getFilterDisplayName(term: FilterTerm, t: TFunction<"explore">): string {
  switch (term.id) {
    case "MANUAL":
      return t("reportPage.manual")
    case "_unset":
      return t("reportPage.unspecified")

    default:
      return term.displayName
  }
}
